var React = require('react');

function PatternTripleTrianglePink (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M60 97H21l20-33 19.5 32.175L80 64l20 33H60zm19.5-33.825L99 31l20 33H40l20-33 19.5 32.175zm1 66L100 97l20 33H41l20-33 19.5 32.175zM140 97l20 33h-40l20-33zm-20-33l20 33h-40l20-33zM20 31l20 33H0l20-33z","fill":"#F79186","fillRule":"evenodd"}));
}

PatternTripleTrianglePink.defaultProps = {"width":"160","height":"160","viewBox":"0 0 160 160"};

module.exports = PatternTripleTrianglePink;

PatternTripleTrianglePink.default = PatternTripleTrianglePink;
